import React from 'react';
import { motion } from 'framer-motion';
const stats = [{
  value: '2–15x',
  label: 'Higher recovery vs. liquidation'
}, {
  value: '180+',
  label: 'Retail & DTC brands'
}, {
  value: '< 1 week',
  label: 'Typical onboarding time'
}, {
  value: '100%',
  label: 'Sell-through on accepted inventory'
}];
export function Stats() {
  return <section id="results" className="bg-forest text-cream" data-id="element-2255" data-mp="2nvh33k2pwl3z">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8" data-id="element-2256" data-mp="297mby84cyot0">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4" data-id="element-2257" data-mp="296b51zfm90xo">
          {stats.map((s, i) => <motion.div key={s.label} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.08
        }} data-id="element-2258" data-mp="2e0p5whd1s09q" data-mpi={i}>
              <p className="font-display text-4xl font-semibold tracking-tight sm:text-5xl" data-id="element-2259" data-mp="1qal0q5k7nsgm">
                {s.value}
              </p>
              <p className="mt-2 text-sm text-cream/70" data-id="element-2260" data-mp="1va7dyf01h8pf">{s.label}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}